import { USER_UPDATE } from './actionTypes';

export const userUpdate = user => {
  return {
    type: USER_UPDATE,
    user
  };
};
